import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { succsesDataAddAlert } from "../../alerts/alerts";
import { useSendFormMutation } from "../../redux/services/crmAPI";

const Ttn = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const [ttn, setTtn] = useState("");
    const [isProblem, setIsProblem] = useState(0);
    const [note, setNote] = useState("");

    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            ttn: ttn,
            is_problem: isProblem,
            note: note,
        };

        await sendForm({ body: formData, url: "ttns", method: "POST" }).unwrap();

        if (!isError) {
            succsesDataAddAlert();
            // navigate("/novaposhta/1");
        }
    };

    return (
        <div className="content">
            <div id="page-header">
                <h1>Нова ТТН</h1>
            </div>
            <div className="form user_form">
                <input
                    type="hidden"
                    name="id"
                    value=""
                />
                <input
                    type="hidden"
                    name="user_id"
                    value=""
                />
                <input
                    type="hidden"
                    name="order_id"
                    value=""
                />
                <div className="row">
                    <div className="col-12 col-sm-6 col-lg-6">
                        <div className="card">
                            <div className="card-header">
                                Номер ТТН
                                <div className="custom-control custom-checkbox float-end">
                                    <input
                                        type="checkbox"
                                        id="check_have_problem"
                                        name="have_problem"
                                        className="form-check-input mx-1 mt-1"
                                        checked={isProblem}
                                        onChange={(e) => setIsProblem(+e.target.checked)}
                                    />
                                    <label
                                        className="custom-control-label"
                                        for="check_have_problem"
                                    >
                                        Проблемна (підміна / розбито)
                                    </label>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Номер ТТН</label>
                                    <input
                                        className="form-control"
                                        name="ttn"
                                        maxLength="255"
                                        value={ttn}
                                        onChange={(e) => setTtn(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="d-block">Відправник </label>
                                    <input
                                        className="form-control"
                                        value=""
                                        name="PhoneSender"
                                        maxLength="255"
                                        type="text"
                                        required=""
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Примітка</label>
                                    <textarea
                                        className="form-control"
                                        name="note"
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                    ></textarea>
                                </div>
                                {/* <div className="mb-3">
                                    <label className="form-label">Товари</label>
                                    <table className="table table-striped purchases_table" id="moves">
                                    </table>
                                    <div id="add_purchase">
                                        <input type="text" name="related" id="add_purchase" className="input_autocomplete form-control" placeholder="Виберіть товар, для того щоб дадати його" autocomplete="off" />
                                    </div>
                                </div> */}
                                {permissions.includes("novaposhta_section") || permissions.includes("all") ? (
                                    <div className="saves_block">
                                        <button
                                            name="user_info"
                                            className="btn btn-primary"
                                            onClick={sendFormHandler}
                                        >
                                            {isLoading ? "Завантаження" : "Зберегти"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-6">
                        <div className="card">
                            <div className="card-header">Інформація ТТН</div>
                            <div className="card-body">
                                <table
                                    className="table table-striped"
                                    style={{ marginBottom: "0" }}
                                ></table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ttn;
